import {createContext} from 'preact';
import {useMemo, useState} from 'preact/hooks';

import {PropsWithChildren} from 'utilities/props';

import {DeliveryEstimateState, DeliveryEstimates} from './types';

interface DeliveryEstimateContextProps {
  deliveryEstimate: DeliveryEstimates | null;
  variantId: number | null;
  setDeliveryEstimate: (
    deliveryEstimates: DeliveryEstimateState | null,
  ) => void;
}

export const DeliveryEstimateContextImpl =
  createContext<DeliveryEstimateContextProps>({
    deliveryEstimate: null,
    variantId: null,
    setDeliveryEstimate: () => {},
  });

export function DeliveryEstimateContextProvider({children}: PropsWithChildren) {
  const [deliveryEstimateState, setDeliveryEstimate] =
    useState<DeliveryEstimateState | null>(null);

  const value = useMemo(
    () => ({
      deliveryEstimate: deliveryEstimateState?.deliveryEstimates ?? null,
      variantId: deliveryEstimateState?.variantId ?? null,
      setDeliveryEstimate,
    }),
    [deliveryEstimateState, setDeliveryEstimate],
  );

  return (
    <DeliveryEstimateContextImpl.Provider value={value}>
      {children}
    </DeliveryEstimateContextImpl.Provider>
  );
}
